import { type FC } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import { useCAForCard } from '../../hooks/card/useCAForCard';

import { SpecialGeoList } from './components/SpecialGeoList/SpecialGeoList';

export const CardSpecialGeoListContainer: FC = () => {
  const {
    geo: { transports },
  } = useCardOfferDataContext();

  const caForCard = useCAForCard();

  return (
    <SpecialGeoList
      trackClick={(): void => caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_listing_waypoint' })}
      transports={transports}
      onClick={stopPropagation}
    />
  );
};
